import { useState, useEffect } from "react";
export const useAsyncActionMenu = (isVisible, actions, update) => {
    const [asyncActions, setAsyncActions] = useState([]);
    const [isError, setIsError] = useState(false);
    useEffect(() => {
        if (!isVisible || !actions) {
            return;
        }
        // clear previous actions or error
        setAsyncActions([]);
        setIsError(false);
        if (Array.isArray(actions)) {
            setAsyncActions(actions);
            return;
        }
        Promise.resolve(typeof actions === "function" ? actions() : [])
            .then((returnedActions) => {
            setAsyncActions(returnedActions);
        })
            .catch(() => {
            // TODO: consider showing users error like error.message ?
            setIsError(true);
        });
    }, [isVisible]);
    useEffect(() => {
        // reposition the portal when menu content is loaded
        update === null || update === void 0 ? void 0 : update();
    }, [asyncActions, isError]);
    return {
        asyncActions,
        isError,
    };
};
//# sourceMappingURL=useAsyncActions.js.map